var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13978",
    "data-name": "Group 13978",
    transform: "translate(-181 -274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-thumbs-up",
    "data-name": "Icon feather-thumbs-up",
    d: "M17.632,11.4V6.6A3.629,3.629,0,0,0,13.974,3L9.1,13.8V27H22.851a2.427,2.427,0,0,0,2.439-2.04l1.683-10.8a2.374,2.374,0,0,0-.571-1.935,2.456,2.456,0,0,0-1.868-.825ZM9.1,27H5.439A2.42,2.42,0,0,1,3,24.6V16.2a2.42,2.42,0,0,1,2.439-2.4H9.1",
    transform: "translate(191 284)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1474",
    "data-name": "Rectangle 1474",
    width: 50,
    height: 50,
    transform: "translate(181 274)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbupIcon);
export default __webpack_public_path__ + "static/media/thumbup-icon.efcdf54f4df469539b9d15eb6478a85e.svg";
export { ForwardRef as ReactComponent };